/**
 * @generated SignedSource<<ff0279f6cf3a74b86c38447ff20c05c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ExportTeamToTeamsInput = {
  projectId?: string | null;
  teamName?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ExportTeamToTeamsMutation$variables = {
  input: ExportTeamToTeamsInput;
};
export type ExportTeamToTeamsMutation$data = {
  readonly exportTeamToTeams: {
    readonly project: {
      readonly teamsId: string | null;
    } | null;
  } | null;
};
export type ExportTeamToTeamsMutation = {
  variables: ExportTeamToTeamsMutation$variables;
  response: ExportTeamToTeamsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamsId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExportTeamToTeamsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExportTeamToTeamsPayload",
        "kind": "LinkedField",
        "name": "exportTeamToTeams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExportTeamToTeamsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExportTeamToTeamsPayload",
        "kind": "LinkedField",
        "name": "exportTeamToTeams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c72fbe3cc6356e34a2c51b1841135ca9",
    "id": null,
    "metadata": {},
    "name": "ExportTeamToTeamsMutation",
    "operationKind": "mutation",
    "text": "mutation ExportTeamToTeamsMutation(\n  $input: ExportTeamToTeamsInput!\n) {\n  exportTeamToTeams(input: $input) {\n    project {\n      teamsId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e01e927c168e51d0a82e915196ff6431";

export default node;
